import React from "react";
import { Select, Form } from "antd";
import FormItem from "antd/lib/form/FormItem";
import {
  InputWrapperDrop,
  NoResultsWrap,
  SelectOptionWrapper,
  SelectOptionMainWrapper,
  SelectdropwownStyles
} from "../../Step1Setup/styles";
import { TitleWrapperFont } from "../../Step2LegacyOptions/styles";
import { SelectWrap, MarginSpecific } from "./styles";
const { Option } = Select;
class SelectComponent extends React.Component {
  filterOption = (input, option) =>{
    return option.props.children.props.children.toLowerCase().indexOf(input.toLowerCase())>=0
  }
 
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div data-test="selectComponentBlock">
        <FormItem
          colon={false}
          label={
            (this.props.showTitle === false) ? '':(
            this.props.title === "State" ? (
              <TitleWrapperFont>{this.props.title}</TitleWrapperFont>
            ) : (
              <MarginSpecific marginTop="16px">
                <TitleWrapperFont>{this.props.title}</TitleWrapperFont>
              </MarginSpecific>
            )
            )
          }
         
        >
          {getFieldDecorator(`select ${this.props.id}`, {
            rules: [
              {
                type: "string"
              }
            ]
          })(
            <InputWrapperDrop>
              <SelectOptionMainWrapper>
                <SelectWrap>
                  <SelectdropwownStyles>
                    <div id={this.props.id} style={{ position: "relative" }}>
                      <Select
                        data-test="selComp"
                        getPopupContainer={trigger => trigger.parentNode}
                        name={this.props.name}
                        aria-label={this.props.arialabel}
                        value={this.props.value}
                        showArrow={true}
                        showSearch
                        onBlur={this.props.handleBlur}
                        placeholder={this.props.placeholder}
                        onChange={this.props.handleInputChange}
                        filterOption={this.filterOption}
                        notFoundContent={
                          <NoResultsWrap>No results</NoResultsWrap>
                        }
                      >
                        {this.props.data &&
                          this.props.data.map((freq, index) => (
                            
                            <Option
                              key={index}
                              value={freq.value}
                            >
                              <SelectOptionWrapper>
                                {this.props.id === "contribute"
                                  ? freq
                                  : freq.desc}
                              </SelectOptionWrapper>
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </SelectdropwownStyles>
                </SelectWrap>
              </SelectOptionMainWrapper>
            </InputWrapperDrop>
          )}
        </FormItem>
      </div>
    );
  }
}
const WrappedSelectComponent = Form.create({ name: "select" })(SelectComponent);

export default WrappedSelectComponent;
